import React from "react";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { letzteMonate, fmtMonat } from "@/lib/api";
import { CalendarDays } from "lucide-react";

export const MonthPicker = ({ value, onChange, testId = "month-filter-select" }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger data-testid={testId} className="w-[190px] bg-card">
      <CalendarDays className="h-4 w-4 mr-1 text-muted-foreground" />
      <SelectValue placeholder="Monat wählen" />
    </SelectTrigger>
    <SelectContent>
      {letzteMonate(14).map((m) => (
        <SelectItem key={m} value={m}>
          {fmtMonat(m)}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
